(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const initRepairFinders = (scope = document) => {
    scope.querySelectorAll('[data-gemt-finder]').forEach((finder) => {
      if (finder.dataset.gemtReady === 'true') return;
      finder.dataset.gemtReady = 'true';

      const buttons = [...finder.querySelectorAll('[data-gemt-device]')];
      const empty = finder.querySelector('[data-gemt-empty]');
      const result = finder.querySelector('[data-gemt-result]');
      const title = finder.querySelector('[data-gemt-result-title]');
      const issueSelect = finder.querySelector('[data-gemt-issue-select]');
      const link = finder.querySelector('[data-gemt-result-link]');

      if (!buttons.length || !result || !issueSelect || !link) return;

      const selectDevice = (button) => {
        buttons.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
        });

        let issues = [];
        try {
          issues = JSON.parse(button.dataset.issues || '""')
            .split(/\r?\n/)
            .map((item) => item.trim())
            .filter(Boolean);
        } catch (_) {
          issues = [];
        }

        issueSelect.replaceChildren();
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Choose the closest issue';
        issueSelect.appendChild(placeholder);

        issues.forEach((issue) => {
          const option = document.createElement('option');
          option.value = issue;
          option.textContent = issue;
          issueSelect.appendChild(option);
        });

        if (title) title.textContent = button.dataset.label || button.textContent.trim();
        link.href = button.dataset.url || link.dataset.defaultUrl || '/pages/start-a-repair';
        link.dataset.baseUrl = link.href;
        link.textContent = button.dataset.cta || 'Start this repair';
        if (empty) empty.hidden = true;
        result.hidden = false;
      };

      buttons.forEach((button) => button.addEventListener('click', () => selectDevice(button)));

      issueSelect.addEventListener('change', () => {
        const base = link.dataset.baseUrl || link.href;
        const selectedButton = buttons.find((button) => button.getAttribute('aria-pressed') === 'true');
        const params = new URLSearchParams();
        if (selectedButton?.dataset.label) params.set('device', selectedButton.dataset.label);
        if (issueSelect.value) params.set('issue', issueSelect.value);
        link.href = `${base.split('?')[0]}${params.toString() ? `?${params}` : ''}`;
      });
    });
  };

  const initRepairRequestPrefill = (scope = document) => {
    scope.querySelectorAll('[data-gemt-repair-form]').forEach((form) => {
      if (form.dataset.gemtPrefilled === 'true') return;
      form.dataset.gemtPrefilled = 'true';

      const params = new URLSearchParams(window.location.search);
      const device = params.get('device');
      const issue = params.get('issue');
      const deviceField = form.querySelector('[name="contact[Device type]"]');
      const issueField = form.querySelector('[name="contact[Issue]"]');

      if (device && deviceField) deviceField.value = device;
      if (issue && issueField) issueField.value = issue;
    });
  };

  const initProductForms = (scope = document) => {
    scope.querySelectorAll('[data-gemt-product-form]').forEach((form) => {
      if (form.dataset.gemtReady === 'true') return;
      form.dataset.gemtReady = 'true';

      const select = form.querySelector('[data-gemt-variant-select]');
      const price = form.closest('[data-gemt-product]')?.querySelector('[data-gemt-product-price]');
      const compare = form.closest('[data-gemt-product]')?.querySelector('[data-gemt-product-compare]');
      const submit = form.querySelector('[type="submit"]');

      if (!select) return;

      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        if (submit) {
          const available = option.dataset.available === 'true';
          submit.disabled = !available;
          submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldLabel;
        }
      };

      select.addEventListener('change', update);
      update();
    });
  };

  const initReveal = (scope = document) => {
    const elements = [...scope.querySelectorAll('.gemt-reveal:not([data-gemt-reveal-ready])')];
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('gemt-is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gemt-is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

    elements.forEach((element) => {
      element.dataset.gemtRevealReady = 'true';
      observer.observe(element);
    });
  };

  const initMobileActions = (scope = document) => {
    if (scope.querySelector('[data-gemt-mobile-actions]')) {
      document.body.classList.add('gemt-has-mobile-actions');
    }
  };

  const init = (scope = document) => {
    initRepairFinders(scope);
    initRepairRequestPrefill(scope);
    initProductForms(scope);
    initReveal(scope);
    initMobileActions(scope);
  };

  onReady(() => init(document));

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();